import ShiftRequirementEdit from '@/components/ezuro/constants/shifts/requirements/edit/ShiftRequirementEdit.vue'

export default {
  name: 'ShiftRequirements',
  components: {
    ShiftRequirementEdit
  },
  props: {
    isModal: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      shift: {},
      events: null,
      isLoading: false,
      isMounted: false
    }
  },
  computed: {
    tableHeaders () {
      const headers = [
        { key: 'id', label: this.$t('general.item.id') },
        { key: 'type', label: this.$t('shift.requirements.type.name'), format: 'formatFunc', funcs: [this.translateType] },
        { key: 'value', label: this.$t('shift.requirements.value'), format: 'formatFunc', funcs: [this.getValueName] }
      ];

      const actions = [
        { label: this.$t('general.actions.edit'), emit: 'editItem', bicon: 'pencil-fill', class: 'btn-sm btn-primary' },
        { label: this.$t('general.actions.delete'), emit: 'deleteItem', bicon: 'trash', class: 'btn-sm btn-danger' }
      ];

      headers.push({ key: 'actions', label: '', actions, classTd: 'w-10' });

      return headers;
    },
    tableActions () {
      const actions = { download: false };
      actions.add = { title: this.$t('general.actions.add') };
      return actions;
    },
    getTitle () {
      return this.$t('shift.requirements.title', { name: this.shift.name });
    }
  },
  methods: {
    getValueName (value, row) {
      if (row.item.type == 'qualification') {
        return this.$store.getters.getParamFromConfig('qualifications', value, 'name', this.$i18n.locale);
      } else if (row.item.type == 'job') {
        return this.$store.getters.getParamFromConfig('company_jobs', value, 'name', this.$i18n.locale);
      } else if (row.item.type == 'user') {
        return row.item.user.fullname;
      }
      return value;
    },
    translateType (action) {
      return this.$t('shift.requirements.type.options.' + action);
    },
    loadEvents () {
      const path = `ezuro/shifts/requirements/list/${this.shift.id}`;

      this.isLoading = true;
      this.currentReq = this.ApiRequest.request(path, this.ApiRequest.REQUEST_GET, {}, (response) => {
        if (response.data) {
          this.events = response.data;
          this.isLoading = false;
        }
      });
    },
    editItem (el) {
      this.$refs.editElFrm.show(el, this.shift);
    },
    deleteItem (el, approved) {
      if (approved) {
        this.setDeleted(el, 1);
      } else {
        this.$refs.itemDeleteMsgBox.show(el, this.$t('general.item.deleteTitle'), this.$t('general.item.deleteMessage', { name: el.type, code: el.id }))
      }
    },
    setDeleted (el, isDeleted) {
      this.isLoading = true;
      this.ApiRequest.request('ezuro/shifts/requirements/destroy/' + el.id, this.ApiRequest.REQUEST_GET, { }, (response) => {
        if (response.error) {
          this.ApiRequest.displayErrorDialog(response, this);
          this.isLoading = false;
        } else {
          this.loadEvents();
        }
      });
    },
    show (elData) {
      this.shift = elData;
      this.loadEvents();

      if (this.isModal) {
        this.$refs['modal-window'].show();
      }
    }
  },
  mounted () {
    this.isMounted = true;
  }
}
